<template>
  <Teleport to="body">
    <transition
      enter-active-class="transition-opacity duration-300 ease-out"
      leave-active-class="transition-opacity duration-300 ease-in"
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
    >
      <div
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-[9000] backdrop-blur-sm p-4"
        @click.self="closeModal"
      >
        <transition
          enter-active-class="transform transition-all duration-300 ease-out"
          leave-active-class="transform transition-all duration-300 ease-in"
          enter-from-class="scale-95 opacity-0"
          leave-to-class="scale-95 opacity-0"
        >
          <div
            class="bg-white rounded-xl shadow-lg relative flex flex-col items-center justify-center overflow-hidden"
            :class="[
              'w-full max-w-[1226px]',
              'h-[90dvh] max-h-[90dvh]',
              '4xl:max-w-[1532px]', 
              '5xl:max-w-[1839px]', 
            ]"
          >
            <div class="w-full h-full relative overflow-hidden rounded-xl">
              <ClusterMap
                v-if="markers && markers.length"
                :markers="markers"
                :isFullscreen="true"
                @on-minimize="closeModal"
                :legends="legends"
                class="w-full h-full"
                @on-maintenance-click="onMaintenanceClick"
              />
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </Teleport>
</template>

<script>
import ClusterMap from "../maps/maps/clusterMap.vue";

export default {
  props: {
    legends: {
      type: Array,
      required: true,
    },
    markers: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  components: {
    ClusterMap,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
    onMaintenanceClick() {
      this.$emit("on-maintenance-click");
    },
  },
  mounted() {
    document.body.classList.add("overflow-hidden");
  },
  beforeUnmount() {
    document.body.classList.remove("overflow-hidden");
  },
};
</script>